import { render, staticRenderFns } from "./centroCusto.vue?vue&type=template&id=1a86a00c"
import script from "./centroCusto.vue?vue&type=script&lang=js"
export * from "./centroCusto.vue?vue&type=script&lang=js"
import style0 from "./centroCusto.vue?vue&type=style&index=0&id=1a86a00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports